import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/scss/app.scss"

import VueFeather from 'vue-feather';
import Breadcrumbs from './components/BreadCrumbs.vue'
import { createI18n } from 'vue-i18n'
import English from "./locales/en.json"
import Spanish from "./locales/es.json"
import French from "./locales/fr.json"
import Portuguese from "./locales/pt.json"

const i18n = createI18n({ legacy: false, 
  locale: 'English',
  messages: {
   English: English,
    Spanish: Spanish,
    French: French,   
   Portuguese: Portuguese,
    }
  })

createApp(App)
.use(store)
.use(router)
.use(i18n)
.component(VueFeather.name, VueFeather)
.component('Breadcrumbs', Breadcrumbs)
.mount('#app')
